<template>
  <div>
    <main class="container mt-5">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  props: {},
  title: 'Login',
};
</script>